import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import { recordEvent } from '../../../services/events-service';

const Container = styled.div`
  padding-left: 6.5vw;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.linearGradientDarkThemeRect};
  ${props => (!props.theme.isMobile && `
    justify-content: center;
  `)}
  ${props => (props.theme.isXLarge && `
    width: 67%;
  `)}
`;

const Logo = styled(Img)`
  margin-top: 197px;
  width: 162px;
  position: relative;
`;

const Header = styled.div`
  margin-top: ${props => (props.theme.isMobile ? '49px' : '70px')};
  width: ${props => (props.theme.isMobile ? '87vw' : '35vw')};
  max-width: 504px;
  font-size: ${props => (props.theme.isMobile ? '33px' : '39px')};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  color: ${props => props.theme.bodyBackgroundColor};
  position: relative;
`;

const SectionContainer = styled.div`
  margin-top: ${props => (props.theme.isMobile ? '0px' : '48px')};
  display: flex;
  flex-direction: ${props => (props.theme.isMobile ? 'column' : 'row')};
  position: relative;
`;

const Section = styled.div`
  margin-right: ${props => (props.theme.isMobile ? '0px' : '59px')};
  width: ${props => (props.theme.isMobile ? '87vw' : '14vw')};
  max-width: ${props => (props.theme.isMobile ? '87vw' : '202px')};
`;

const SectionLine = styled.div`
  border-top: 3px solid ${props => props.theme.primaryColor};
  margin-top: ${props => (props.theme.isMobile ? '28px' : '0px')};
  width: ${props => (props.theme.isMobile ? '202px' : '14vw')};
  position: relative;
`;

const SectionHeader = styled.div`
  font-size: 20px;
  font-family: ${props => props.theme.fontFamilySubheader};
  font-weight: ${props => props.theme.fontWeightBlack};
  color: ${props => props.theme.bodyBackgroundColor};
  text-transform: uppercase;
  margin-top: ${props => (props.theme.isMobile ? '25px' : '12px')};
  position: relative;
`;

const SectionBody = styled.p`
  font-size: 15px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  color: ${props => props.theme.bodyBackgroundColor};
  letter-spacing: 0;
  line-height: 15px;
  position: relative;
`;

const About = styled.div`
  margin-top: ${props => (props.theme.isMobile ? '43px' : '70px')};
  font-size: 20px;
  font-family: ${props => props.theme.fontFamilySubheader};
  font-weight: ${props => props.theme.fontWeightBlack};
  color: ${props => props.theme.bodyBackgroundColor};
  text-transform: uppercase;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ArrowLine = styled.div`
  border-top: 2px solid ${props => props.theme.primaryColor};
  display: inline-block;
  margin-left: 10px;
  height: 7px;
  width: 14px;
`;

const ArrowTriangle = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 0 6px 14px;
  border-color: transparent transparent transparent ${props => props.theme.primaryColor};
  display: inline-block;
`;

const Copyright = styled.div`
  margin-top: ${props => (props.theme.isMobile ? '80px' : '25%')};
  font-size: 15px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  color: ${props => props.theme.bodyBackgroundColor};
  position: relative;
`;

export default function LivewireBrand() {
  const {
    logo, isMobile,
  } = React.useContext(ThemeContext);

  const tolCTAClick = () => {
    const page = window.location.pathname;

    recordEvent({
      event: 'tol_landing_cta_clicked',
      id: 0,
      statisticable: 'navigation',
      page,
      custom_data: { page, section: 'free newsletter' },
    });
  };

  return (
    <Container>
      {!isMobile && <Logo src={logo} />}
      <Header>
        Australia’s #1 website for expert investment analysis
      </Header>
      <SectionContainer>
        <Section>
          <SectionLine />
          <SectionHeader>Insights</SectionHeader>
          <SectionBody>
            Access investment commentary and analysis from Australia’s leading money managers.
          </SectionBody>
        </Section>
        <Section>
          {!isMobile && <SectionLine />}
          <SectionHeader>Ideas</SectionHeader>
          <SectionBody>
            Receive our leading newsletter ‘Trending on Livewire’ direct to your inbox, daily.
          </SectionBody>
        </Section>
        <Section>
          {!isMobile && <SectionLine />}
          <SectionHeader>Features</SectionHeader>
          <SectionBody>
            Follow your most trusted fund managers and never miss their investment
            ideas and analysis.
          </SectionBody>
          {isMobile && <SectionLine />}
        </Section>
      </SectionContainer>
      <About>
        <div>
          LEARN MORE ABOUT &nbsp;
          <a href="/company/our_story">
            LIVEWIRE
            <ArrowLine />
            <ArrowTriangle />
          </a>
        </div>
        <div>
          SIGNUP FOR OUR &nbsp;
          <a href="/subscribe" onClick={tolCTAClick}>
            FREE NEWSLETTER
            <ArrowLine />
            <ArrowTriangle />
          </a>
        </div>
      </About>
      <Copyright>&copy; Livewire Markets Pty Ltd. All rights reserved</Copyright>
    </Container>
  );
}
